module.exports = __webpack_public_path__ + "f93159a23efa765856280bdf84fd1391.svg";